import React, { createContext, useContext, useState } from 'react';

import { apiEndpoints, queryKeys, useGetQuery } from '#/services';

export const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }) => {
    const [companiesQueryParams, setCompaniesQueryParams] = useState({});
    const { data: user, refetch: refetchUser } = useGetQuery({ key: queryKeys?.USER, url: apiEndpoints?.GET_USER });
    const { data: Filters, refetch: refetchFilters } = useGetQuery({
        key: queryKeys?.FILTERS,
        url: apiEndpoints?.GET_FILTERS,
    });
    const { data: businessTypesData, refetch: refetchBusinessTypes } = useGetQuery({
        url: apiEndpoints?.GET_BUSINESS_TYPES,
    });

    const context = {
        user,
        refetchUser,
        Filters,
        refetchFilters,
        businessTypesData,
        refetchBusinessTypes,
        companiesQueryParams,
        setCompaniesQueryParams,
    };

    return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};
